// extracted by mini-css-extract-plugin
module.exports = {"preview":"Preview_preview__GLXJe","content":"Preview_content__ohQzl","flexBox":"Preview_flexBox__2OkFX","maxImg":"Preview_maxImg__eEFQq","closeBtn":"Preview_closeBtn__TCNp7"};